"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUUID = isUUID;
const __1 = require("..");
function isUUID(input = '') {
    if (typeof input !== 'string' || !__1.REGEXP_UUID.test(input)) {
        return false;
    }
    return input;
}
//# sourceMappingURL=is-uuid.util.js.map